import { UntypedFormGroup } from "@angular/forms";

export function PasswordValidator(form: UntypedFormGroup) {
	const password = form.get("newPassword").value;
	const confirmPassword = form.get("verifyPassword").value;

	return password === confirmPassword ? null : { passwordValidator: { valid: false } };
}
